import React, { Component, componentDidMount } from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";

class DevBox extends Component {

    componentDidMount() {
        Aos.init({ duration: 700,
            delay:200});
    }

    render() {
        return (
            <div className="devbox"  data-aos="fade-left" data-aos-delay="50">
                <h3>{this.props.title}</h3>
                <p>{this.props.text}</p>
            </div>
        );
    }
}

export default DevBox;
